import axios, { AxiosError } from "axios"
import { Dispatch } from "../store.config"

import { AnyAction } from "redux"

export enum KPIsActionEnum {
  GET_KPIS_ATTEMPT = "KPIS/getKPIsAttempt",
  GET_KPIS_SUCCESS = "KPIS/getKPIsSuccess",
  GET_KPIS_FAILURE = "KPIS/getKPIsFailure",
}

export const getFiduciaryKPIsAttemptAction = () =>
  ({ type: KPIsActionEnum.GET_KPIS_ATTEMPT } as const)
export const getFiduciaryKPIsSuccessAction = (filesArray: Array<KPIFile>) =>
  ({ type: KPIsActionEnum.GET_KPIS_SUCCESS, filesArray } as const)
export const getFiduciaryKPIsFailureAction = (error: AxiosError) =>
  ({ type: KPIsActionEnum.GET_KPIS_FAILURE, error } as const)

export type KPIsActionType = ReturnType<
  | typeof getFiduciaryKPIsAttemptAction
  | typeof getFiduciaryKPIsSuccessAction
  | typeof getFiduciaryKPIsFailureAction
>

export interface KPIFile {
  Dossier: string
  Dépôts: number
  Achats: number
  Ventes: number
  "En cours": number
  "Autres factures": number
  "Dossier permanent": number
  Banque: number
  "Fiscal et Social": number
  id: number
}

export interface KPIsState {
  files: {
    [index: number]: KPIFile
  }
  startDate: string
  endDate: string
}

export const KPIsInitialState: KPIsState = {
  files: {},
  startDate: "",
  endDate: "",
}

export function KPIsReducer(state = KPIsInitialState, action: KPIsActionType) {
  switch (action.type) {
    case KPIsActionEnum.GET_KPIS_SUCCESS:
      return {
        ...state,
        files: action.filesArray.reduce(
          (acc: KPIsState["files"], current: KPIFile) => ({
            ...acc,
            [current.id]: { ...current },
          }),
          {}
        ),
      }
    default:
      return state
  }
}

export const getFiduciaryKPIsThunk =
  (fiduciaryId: number, dateParams: { startDate: string; endDate: string }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getFiduciaryKPIsAttemptAction())
    return axios
      .get<KPIFile[]>(`/fiduciaries/${fiduciaryId}/kpis`, {
        params: {
          start_date: dateParams.startDate,
          end_date: dateParams.endDate,
        },
      })
      .then(({ data }) => {
        dispatch(getFiduciaryKPIsSuccessAction(data))
      })
      .catch((e: AxiosError) => {
        dispatch(getFiduciaryKPIsFailureAction(e))
      })
  }
